import type { SearchFilters } from '@rover/types/src/SearchFilters';

/**
 * Whether core search is displaying results for a bounding box rather than a center point,
 * which specialty search cannot represent. See the CoreToSpecialtySearchUnconvertibleLocation
 * metric for more context.
 *
 * The condition mirrors `shouldAddSearchBounds` in `validateAndSetSearchBounds`, which is
 * what actually decides whether core applies the bounds. Core discards the bounds unless all
 * four values are present *and* both dimensions span a range.
 */
const hasUnconvertibleSearchBounds = ({
  minlat,
  maxlat,
  minlng,
  maxlng,
}: Partial<SearchFilters>): boolean =>
  [minlat, maxlat, minlng, maxlng].every((value) => value !== undefined) &&
  minlat !== maxlat &&
  minlng !== maxlng;

export default hasUnconvertibleSearchBounds;
